export const Update = {
  CREATE_UPDATE: 'update/create-update-queue', // Cria uma nova atualização
  UPDATING_OR_CURRENT_VERSION:
    'update/versions/find-version-updating-or-current', // Retorna versão em atualização ou atual caso não haja versão em atualização
  UPDATE_STATUS: 'update/read-update-queue-status', // Retorna status da fila de atualização
  AREA_LIST: 'update/areas',
  AREA_ID: 'update/areas/{areaId}', // Retorna área tecnológica específica
  AREA_ID_FINALIZE: 'update/area-version/{areaId}/finalize',
  AREA_ID_VERSIONS: 'update/areas/{areaId}/versions',
  AREAS_VERSIONS: 'update/versions',
  AREAS_WITHOUT_VERSION: 'update/areas/without-version',
  AREAS_CNAE_COURSE_ID: 'update/cnae-list/course-version/${courseVersionId}',
  AREAS_CNAE_AREA_VERSION_ID: 'update/cnae-list/area-version/${areaVersionId}',
  COURSE_VERSION_COMPETENCE:
    '/update/course-version/{courseVersionId}/competence',
  COURSE_VERSION_ACCESS_REQUIREMENTS:
    '/update/course/{courseVersionId}/access-requirement',
  ACCESS_REQUIREMENTS: '/update/access-requirement?description={description}',
  CNAE_SECTION: '/update/cnae-section-list',
  CNAE_SECTION_COURSE_VERSION_ID:
    '/update/cnae-section-list/{cnaeSectionId}/course-version/{courseVersionId}',
  CNAE_DIVISION: '/update/cnae-division-list/',
  CNAE_DIVISION_SIMPLE: '/update/cnae-division-list/registered/{sectionId}',
  CNAE_DIVISION_COURSE_VERSION_ID:
    '/update/cnae-division-list/{cnaeDivisionId}/course-version/{courseVersionId}',
  CNAE_GROUP: '/update/cnae-group-list/',
  CNAE_GROUP_SIMPLE: '/update/cnae-group-list/registered/{divisionId}',
  CNAE_GROUP_COURSE_VERSION_ID:
    '/update/cnae-group-list/{cnaeGroupId}/course-version/{courseVersionId}',
  FUNCTION_ID: 'update/function/{functionId}',
  SUBFUNCTION_ID: 'update/subfunction/{subfunctionId}',
  PERFORMANCE_STANDARD_ID:
    'update/performance-standard/{performanceStandardId}',
  EVOLUTION_ID: '/update/evolution-list/{id}',
  EVOLUTION_TYPE: '/evolution-type-list',
  RELATED_FORMATION_ID: '/update/professional-formation/{id}',
  CURRICULAR_UNIT_COURSE_VERSION:
    '/update/curricular-unit-list/{curricularUnitCourseVersionId}',
  DELETE_INFRASTRUCTURE_CURRICULAR_UNIT_COURSE_VERSION:
    'update/infrastructure-list/{infrastructureId}/curricular-unit-course-version/{curricularUnitCourseVersionId}', // Desvincula infraestrutura de unidade curricular
  COURSE_VERSION_ID: 'update/course-version/{courseVersionId}',
  POSITION_OF_FUNCTION_SUBFUNCTION_PERFORMANCE_STANDARD:
    'update/position-of-function-subfunction-performance-standard',
  MODULE_COURSE_VERSION: '/update/module-course-version',
  INFRASTRUCTURE_LIST: '/update/infrastructure-list',
  INFRASTRUCTURE_ID: '/update/infrastructure-list/{infrastructureId}',
} as const
